/* eslint-disable */
import React, { useContext, useState } from 'react';
import { Button, Col, Collapse, Form, Row, Select, Spin, notification } from 'antd';
import PropTypes from 'prop-types';
import './styles.less';
import { EnrollmentFormContext } from '../../../../../../providers/EnrollmentFormContextProvider';
import useParams from '../../../../../params/useParams';
import paramEndpoints from '../../../../../params/paramEndpoints';
import useEnrollmentUpdate from '../../../../../../hooks/useEnrollmentUpdate';
import Header from './Header';
import ContentCollapse from './Content';
import AuthorizedPersonContent from './AuthorizedPersonContent';
import file from '../../../../../../utils/file';
import DocumentTypeKey from '../../../../../../enums/DocumentTypeKey';

const { Panel } = Collapse;

const PersonalDocuments = ({ onFinish }) => {
  const [executives, areExecutivesLoading] = useParams(paramEndpoints.EXECUTIVES);
  const [updateEnrollment, isLoading] = useEnrollmentUpdate();
  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const [forceRender, setForceRender] = useState(true);

  const handleSubmit = async () => {
    try {
      await enrollmentForm.validateFields();
      const formValues = enrollmentForm.getFieldsValue(true);
      // if (
      //   Array.isArray(formValues.legalRepresentatives) &&
      //   Array.isArray(formValues.mandataryPeople)
      // ) {
      //   // se chequea minimo la existencia del primer elemento del arreglo de datos por cada drawer
      //   // lo malo es que si solo llena el campo a validar pasa la validacion.
      //   if (
      //     formValues.mandataryPeople[0].identification !== '' &&
      //     formValues.legalRepresentatives[0].serialNumber !== ''
      //   ) {
      // no se sabe cuando estan los datos en la base  , se asume que si existen cualquiera de los campos serialnuember y identification
      // paso por el proceso de  guardado  en los drawer anteriores. NO EXISTEN CAMPOS PARA CHEQUAR QUE  GUARDO LA INFORMACION , SINO
      // TENDRIA QUE VALIDAR LA EXISTENCIA DE CADA CAMPOS DE LOS DRAWERS
      const { executiveId } = formValues;
      const legalRepresentatives = await Promise.all(
        formValues.legalRepresentatives.map(async (legalRepresentative) => {
          const documents = [];

          await Promise.all(
            (legalRepresentative.ciDocuments || []).map(async (uploadedFile) => {
              const { name, originFileObj } = uploadedFile;
              const base64 = await file.toBase64(originFileObj);

              documents.push({
                filename: name,
                base64,
                typeKey: DocumentTypeKey.LEGAL_REPRESENTATIVE_CI,
              });
            })
          );
          return {
            ...legalRepresentative,
            documents,
          };
        })
      );

      const mandataryPeople = await Promise.all(
        formValues.mandataryPeople
          ? formValues.mandataryPeople.map(async (mandataryPerson) => {
              const documents = [];

              await Promise.all(
                (mandataryPerson.documents || []).map(async (uploadedFile) => {
                  const { name, originFileObj } = uploadedFile;
                  const base64 = await file.toBase64(originFileObj);

                  documents.push({
                    filename: name,
                    base64,
                    typeKey: DocumentTypeKey.MANDATARY_PERSON_POWER,
                  });
                })
              );

              return {
                ...mandataryPerson,
                documents,
              };
            })
          : []
      );
      const updatePayload = {
        executiveId,
        legalRepresentatives,
        mandataryPeople,
        legalPerson: undefined,
      };
      updateEnrollment(updatePayload);
      onFinish();
    } catch (e) {
      notification.error({
        message: 'Falta Lenar Datos del Formulario',
        description:
          ' Debe llenar los datos del Representante Legal y Mandatario o Persona autorizada.',
      });
    }
  };

  const legalRepresentatives = enrollmentForm.getFieldValue('legalRepresentatives');

  const mandataryPeople = enrollmentForm.getFieldValue('mandataryPeople');

  return (
    <Spin spinning={isLoading}>
      <Form form={enrollmentForm} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              name="executiveId"
              label="Ejecutivo de contacto VanTrust"
              initialValue={0}
              rules={[
                {
                  required: true,
                  message: 'Dato requerido',
                },
              ]}
            >
              <Select loading={areExecutivesLoading} disabled={areExecutivesLoading}>
                {!areExecutivesLoading && (
                  <Select.Option value={0}>No tengo ejecutivo asignado</Select.Option>
                )}
                {executives.map((executive) => (
                  <Select.Option key={executive.id} value={executive.id}>
                    {executive.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Form form={enrollmentForm} layout="vertical" onFinish={handleSubmit}>
        <Col span={24}>
          <h1>Representantes Legales</h1>
        </Col>

        <Collapse ghost>
          {(legalRepresentatives || [{}]).map((legalRepresentative, index) => (
            <Panel
              header={<Header title={`Representante Legal ${index + 1}`} />}
              key={index}
              forceRender={forceRender}
            >
              <ContentCollapse
                text={
                  legalRepresentative?.name
                    ? `${legalRepresentative.name} ${legalRepresentative.firstSurname}, ${
                        legalRepresentative.identification
                      } ${index + 1}`
                    : `Representante Legal ${index + 1}`
                }
                title={`Representante Legal ${index + 1}`}
                index={index}
                setForceRender={setForceRender}
                forceRender={forceRender}
              />
            </Panel>
          ))}
        </Collapse>

        <Col span={24}>
          <h1>Mandatarios y/o Personas Autorizadas para Firmar</h1>
        </Col>

        <Form.List name={'mandataryPeople'}>
          {(fields, { add, remove }) => (
            <Row>
              <Col span={24}>
                <Collapse ghost>
                  <>
                    {fields.map((field, index) => (
                      <Panel
                        header={<Header title={`Mandatario o Persona Autorizada ${index + 1}`} />}
                        key={index}
                        forceRender={forceRender}
                      >
                        <AuthorizedPersonContent
                          text={
                            mandataryPeople?.[index]?.name
                              ? `${mandataryPeople?.[index]?.name} ${
                                  mandataryPeople?.[index]?.firstSurname
                                }, ${mandataryPeople?.[index]?.identification} ${index + 1}`
                              : `Mandatario o Persona Autorizada ${index + 1}`
                          }
                          title={`Mandatario o Persona Autorizada ${index + 1}`}
                          field={field}
                          onRemove={remove}
                          setForceRender={setForceRender}
                          forceRender={forceRender}
                        />
                      </Panel>
                    ))}
                  </>
                </Collapse>
              </Col>
              <Col xs={24} lg={18}>
                <Form.Item>
                  <Button type={'dashed'} onClick={() => add({})} block>
                    + Agregar Mandatario o Persona Autorizada
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form.List>

        <Row>
          <Col lg={10} xs={24}>
            <Button
              className="enrollmentLegalFormContainer__button"
              type="primary"
              onClick={handleSubmit}
            >
              Continuar
            </Button>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

PersonalDocuments.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default PersonalDocuments;
